// ============================================================================
// File: src/modules/ppe/pages/procurement/dashboard/components/charts/ProcurementFunnelChart.jsx
// Purpose:
//   Displays Procurement Flow Funnel (Enterprise Styled)
// ============================================================================

import React from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Cell
} from "recharts";

export default function ProcurementFunnelChart({ data }) {

  if (!data || data.length === 0) {
    return null;
  }

  // ---------------------------------------------------------------------------
  // ENTERPRISE COLOR MAP (Stage Based)
  // ---------------------------------------------------------------------------
  const stageColors = {
    Indent: "#4f7cff",   // Blue
    PR: "#9c36ff",       // Purple
    RFQ: "#58677c",      // Indigo/Grey
    PO: "#ff8a00",       // Orange
    GRN: "#2fbf71"       // Green
  };

  // ---------------------------------------------------------------------------
  // CUSTOM TOOLTIP
  // ---------------------------------------------------------------------------
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div
          style={{
            background: "#fff",
            border: "1px solid #e5e7eb",
            padding: "8px 12px",
            borderRadius: "8px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)"
          }}
        >
          <strong>{label}</strong>
          <div>{payload[0].value} documents</div>
        </div>
      );
    }
    return null;
  };

  // ---------------------------------------------------------------------------
  // RENDER
  // ---------------------------------------------------------------------------
  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart
        data={data}
        margin={{ top: 10, right: 20, left: 0, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" stroke="#eef1f5" />

        <XAxis
          dataKey="stage"
          tick={{ fontSize: 12 }}
          axisLine={false}
          tickLine={false}
        />

        <YAxis
          tick={{ fontSize: 12 }}
          axisLine={false}
          tickLine={false}
        />

        <Tooltip content={<CustomTooltip />} />

        <Bar
          dataKey="value"
          radius={[6, 6, 0, 0]}
          animationDuration={800}
        >
          {data.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={stageColors[entry.stage] || "#4f7cff"}
            />
          ))}
        </Bar>

      </BarChart>
    </ResponsiveContainer>
  );
}
